import { render } from "./제증명발급.vue?vue&type=template&id=38fd70c3"
import script from "./제증명발급.vue?vue&type=script&lang=js"
export * from "./제증명발급.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__